export const VERIFY_PAYMENT_SUCCESS = 'VERIFY_PAYMENT_SUCCESS'
export const VERIFY_PAYMENT_REQUEST = 'VERIFY_PAYMENT_REQUEST'
export const VERIFY_PAYMENT_FAILURE = 'VERIFY_PAYMENT_FAILURE'
export const VERIFY_PAYMENT_RESET = 'VERIFY_PAYMENT_RESET'
